import { isLanguageSwitcherEnabled } from '@/lib/i18n-config';
import { I18nProvider } from '@kgc/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { consoleCapture, networkCapture } from './components/helpdesk';
import './index.css';
import { startMockApi } from './mocks/start-mock-api';

// Helpdesk auto-capture init — app bootstrap-kor, mindent fog indulástól
consoleCapture.init();
networkCapture.init();

function render() {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  createRoot(rootElement).render(
    <StrictMode>
      <I18nProvider honorPersistedLocale={isLanguageSwitcherEnabled()}>
        <App />
      </I18nProvider>
    </StrictMode>
  );
}

// Day-1-unblock: dev-módban mock-API indul (ha VITE_USE_REAL_API!=true), majd render.
// Prod-build / VITE_USE_REAL_API=true esetén a startMockApi azonnal no-op → változatlan viselkedés.
void startMockApi().finally(render);
